var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.display
    ? _c("div", { staticClass: "modal-popup" }, [
        _c("div", { ref: "modalPopup", staticClass: "popup" }, [
          _c("h4", [_vm._v(_vm._s(_vm.title))]),
          _c("p", { domProps: { innerHTML: _vm._s(_vm.subtitle) } }),
          _c("div", { staticClass: "buttons" }, [
            _vm.textCancel.length
              ? _c(
                  "div",
                  {
                    staticClass: "button btn-outline-primary cancel",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.cancelModal.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.textCancel) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
            _vm.textValid.length
              ? _c(
                  "div",
                  {
                    staticClass: "button btn-primary valid",
                    on: {
                      click: function ($event) {
                        $event.stopPropagation()
                        return _vm.validModal.apply(null, arguments)
                      },
                    },
                  },
                  [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.textValid) +
                        "\n            "
                    ),
                  ]
                )
              : _vm._e(),
          ]),
        ]),
      ])
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }